import React, { useEffect, useState } from "react";
import {
  Box, Button, Typography, Container, FormControl, InputLabel, Select, MenuItem,
  TextField, Radio, RadioGroup, FormControlLabel, Tabs, Tab, CircularProgress, IconButton
} from "@mui/material";
import { axiosInstance } from "../../../services/axiosInstance";
import { endpoints } from "../../../services/endpoint";
import "./phoneNumber.css";
import CloseIcon from "@mui/icons-material/Close";
import {
  ArrowDropUp as ArrowDropUpIcon,
  AccountCircle,
  ArrowDropDown as ArrowDropDownIcon,
  ExpandMore as ExpandMoreIcon,
  ArrowBack as ArrowBackIcon,
} from "@mui/icons-material";
 
const AddPhoneNumber = ({
  onClose,
  onAddSuccess,
  region,
}) => {
  const [selectedMethod, setSelectedMethod] = useState("voice");
  const [tabValue, setTabValue] = useState(0);
  const [countryCode, setCountryCode] = useState("");
  const [phoneNumberType, setPhoneNumberType] = useState("TOLL_FREE");
  const [availableNumbers, setAvailableNumbers] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [description, setDescription] = useState("");
  const [contactFlow, setFlow] = useState("");
  const [flowList, setflowList] = useState([]);
    const [actionClicked, setActionClicked] = useState(null); 
  const [loading, setLoading] = useState(false);
  const [cancelButtonLoading, setCancelButtonLoading] = useState(false);
const [errors, setErrors] = useState({
  tab: "",
  countryCode: "",
  phoneNumber: "",
});

  const instanceId = localStorage.getItem("InstanceId");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const username = localStorage.getItem("username");
  const instanceAlias = localStorage.getItem("instanceName");
  const EncryptedInstanceId = localStorage.getItem("EncryptedId");
 const email = localStorage.getItem("Email");
  // Different country codes for Toll Free vs DID
  const countryCodeOptions = {
    TOLL_FREE: [
      { value: " +54 ", label: "Argentina  ", code: "AR " },
      { value: "+61", label: " Australia  ", code: "AU" },
      { value: "+43 ", label: "Austria  ", code: "AT" },
      { value: "+32 ", label: " Belgium  ", code: "BE  " },
      { value: "+673 ", label: "Brunei Darussalam ", code: "BN " },
      { value: "+1 ", label: "Canada", code: "CA" },
      { value: "+56 ", label: "Chile   ", code: "CL " },
      { value: "+57 ", label: "Colombia", code: "CO" },
      { value: "+506 ", label: "Costa Rica", code: "CR" },
      { value: "+357 ", label: " Cyprus", code: "CY" },
      { value: "+420 ", label: " Czech Republic   ", code: "CZ" },
      { value: "+45 ", label: " Denmark", code: "DK" },
      { value: "+1 ", label: "Dominican Republic", code: "DO" },
      { value: "+593 ", label: "Ecuador  ", code: "EC" },
      { value: "+503 ", label: "El Salvador ", code: "SV" },
      { value: "+372 ", label: "Estonia ", code: "EE" },
      { value: "+358 ", label: "Finland ", code: "FI" },
      { value: "+33 ", label: "France ", code: "FR" },
      { value: "+49 ", label: "Germany ", code: "DE" },
      { value: "+30 ", label: "Greece", code: "GR" },
      { value: "+504 ", label: "Honduras ", code: "HN" },
      { value: " +852", label: "Hong Kong ", code: "HK" },
      { value: "+36 ", label: " Hungary", code: "HU" },
      { value: "+354 ", label: "Iceland  ", code: "IS" },
      { value: " +62", label: "Indonesia  ", code: "ID" },
      { value: " +353", label: "Ireland  ", code: "IE" },
      { value: " +39", label: "Italy   ", code: "IT" },
      { value: " +81", label: " Japan ", code: "JP" },
      { value: "+371 ", label: " Latvia ", code: "LV" },
      { value: "+370 ", label: "Lithuania ", code: "LT" },
      { value: " +352", label: "Luxembourg ", code: "LU" },
      { value: " +60", label: " Malaysia ", code: "MY" },
      { value: "+52 ", label: "Mexico", code: "MX" },
      { value: "+31 ", label: " Netherlands ", code: "NL" },
      { value: "+64 ", label: " New Zealand ", code: "NZ" },
      { value: " +505", label: "Nicaragua ", code: "NI" },
      { value: " +507", label: "Panama", code: "PA" },
      { value: "+51 ", label: "Peru", code: "PE" },
      { value: " +48", label: "Poland ", code: "PL" },
      { value: " +351", label: " Portugal ", code: "PT" },
      { value: "+1 ", label: "Puerto Rico ", code: "PR" },
      { value: "+40 ", label: "Romania ", code: "RO" },
      { value: " +381", label: "Serbia", code: "RS" },
      { value: " +65", label: "Singapore  ", code: "SG" },
      { value: "+421 ", label: "Slovakia ", code: "SK" },
      { value: "+386 ", label: "Slovenia  ", code: "SI" },
      { value: " +34", label: "Spain ", code: "ES" },
      { value: " +46", label: "Sweden ", code: "SE" },
      { value: " +41", label: "Switzerland", code: "CH" },
      { value: " +66", label: "Thailand ", code: "TH" },
      { value: "+256 ", label: " Uganda ", code: "UG" },
      { value: "+44 ", label: "United Kingdom ", code: "GB" },
      { value: " +1", label: " United States", code: "US" },
      { value: "+84", label: " Viet Nam  ", code: "VN" },
     


    ],
    DID: [
      { value: "+1", label: "Anguila", code: "AI" },
       { value: "+1 ", label: "Antigua and Barbuda", code: "AG" },
        { value: "+54 ", label: "Argentina", code: "AR" },
         { value: "+61 ", label: "Australia", code: "AU" },
          { value: " +43", label: " Austria", code: "AT" },
 { value: "+1 ", label: "Bahamas", code: "BS" },
 { value: "+1 ", label: "Barbados", code: "BB" },
 { value: "+32 ", label: "Belgium", code: "BE" },
 { value: "+591 ", label: "Bolivia", code: "BO" },
 { value: "+599 ", label: "Bonaire, Sint Eustatius and Saba", code: "BQ" },
 { value: "+1 ", label: "Canada ", code: "CA" },
 { value: "+56 ", label: "Chile ", code: "CL" },
 { value: " +57", label: " Colombia ", code: "CO" },
 { value: "+506 ", label: " Costa Rica ", code: "CR" },
 { value: "+599 ", label: "Curaçao", code: "CW" },
 { value: "+357  ", label: "Cyprus ", code: "CY" },
 { value: "+420 ", label: "Czech Republic ", code: "CZ" },
 { value: "+45 ", label: " Denmark ", code: "DK" },
 { value: "+1 ", label: "Dominican Republic ", code: "DO" },
 { value: "+593 ", label: "Ecuador", code: "EC" },
 { value: "+503 ", label: "El Salvador ", code: "SV" },
 { value: "+372 ", label: " Estonia ", code: "EE" },
 { value: " +358", label: "Finland ", code: "FI" },
 { value: "+33 ", label: "France", code: "FR" },
 { value: "+995 ", label: "Georgia  ", code: "GE" },
 { value: "+49 ", label: "Germany", code: "DE" },
 { value: "+30 ", label: "Greece ", code: "GR" },
 { value: "+502 ", label: "Guatemala", code: "GT" },
 { value: "+504 ", label: "Honduras", code: "HN" },
 { value: "+852 ", label: " Hong Kong ", code: "HK" },
 { value: " +36", label: "Hungary", code: "HU" },
 { value: " +354", label: "Iceland", code: "IS" },
  { value: " +62", label: "Indonesia", code: "ID" }, 
  { value: " +353", label: "Ireland", code: "IE" }, 
  { value: " +39", label: "Italy", code: "IT" }, 
  { value: "+1 ", label: "Jamaica ", code: "JM" }, 
  { value: " +81", label: "Japan ", code: "JP" }, 
  { value: " +371", label: "Latvia ", code: "LV" },
   { value: " +370", label: "Lithuania ", code: "LT" }, 
   { value: " +352", label: "Luxembourg", code: "LU" }, 
   { value: " +60", label: " Malaysia", code: "MY" }, 
   { value: "+52 ", label: "Mexico", code: "MX" }, 
   { value: " +31", label: "Netherlands", code: "NL" }, 
   { value: " +64", label: "New Zealand", code: "NZ" }, 
   { value: " +505", label: "Nicaragua", code: "NI" }, 
   { value: " +507", label: "Panama ", code: "PA" },
    { value: " +51", label: "Peru ", code: "PE" }, 
    { value: " +48", label: "Poland ", code: "PL" },
     { value: "+351 ", label: "Portugal", code: "PT" }, 
     { value: " +1", label: "Puerto Rico ", code: "PR" }, 
     { value: " +40", label: " Romania ", code: "RO" }, 
     { value: "+1 ", label: "Saint Lucia", code: "LC" }, 
     { value: "+590 ", label: "Saint Martin (French part) ", code: "MF" }, 
     { value: "+381 ", label: " Serbia  ", code: "RS" },
      { value: " +65", label: "Singapore ", code: "SG" }, 
      { value: " +1", label: "Sint Maarten (Dutch part)  ", code: "SX" }, 
      { value: " +421", label: " Slovakia  ", code: "SK" }, 
      { value: "+386 ", label: " Slovenia ", code: "SI" }, 
      { value: " +34", label: "Spain ", code: "ES" }, 
      { value: "+46 ", label: "Sweden ", code: "SE" }, 
      { value: " +41", label: "Switzerland", code: "CH" },
      { value: " +66", label: "Thailand ", code: "TH" },
      { value: "+1 ", label: "Trinidad and Tobago ", code: "TT" },
      { value: "+1 ", label: "Turks and Caicos Islands ", code: "TC" },
      { value: "+44 ", label: " United Kingdom ", code: "GB" },
      { value: " +1", label: "United States", code: "US" },
      { value: " +58", label: " Venezuela ", code: "VE" },
      { value: "+84 ", label: "Viet Nam", code: "VN" },
     

    ]
  };

  // Get current country code options based on phone number type
  const currentCountryOptions = countryCodeOptions[phoneNumberType] || [];

  const handleTabChange = (_, newValue) => {
    setTabValue(newValue);
    setPhoneNumberType(newValue === 0 ? "TOLL_FREE" : "DID");
    setAvailableNumbers([]);
    setPhoneNumber("");
    setCountryCode(""); // Reset country code when switching tabs
  };

  const handleCountryCodeChange = (e) => {
    setCountryCode(e.target.value);
    setErrors((prev) => ({ ...prev, countryCode: "" })); // clear error
  
    setPhoneNumber(""); // Reset phone number when changing country
    setAvailableNumbers([]); // Clear available numbers
  };

  useEffect(() => {
  const fetchAvailableNumbers = async () => {
    if (!countryCode || !phoneNumberType) {
      setAvailableNumbers(null); // reset if no country selected
      return;
    }

    setAvailableNumbers(null); // indicate loading

    const selectedCountry = currentCountryOptions.find(
      (option) => option.code === countryCode
    );

    if (!selectedCountry) {
      setAvailableNumbers([]); // no country found → empty list
      return;
    }

    const payload = {
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      InstanceAlias: instanceAlias,
      region,
      PhoneNumberCountryCode: selectedCountry.code,
      PhoneNumberType: phoneNumberType,
    };

    try {
      const response = await axiosInstance.post(
        endpoints.displayAvailablephoneNumber.phonelist,
        payload
      );

      const data = typeof response.data.body === "string"
        ? JSON.parse(response.data.body)
        : response.data.body;

      const phoneNumbers = Array.isArray(data)
        ? data.map((item) => item.PhoneNumber)
        : [];

      setAvailableNumbers(phoneNumbers);
    } catch (err) {
      console.error(err);
      setAvailableNumbers([]); // treat error as empty
    }
  };

  fetchAvailableNumbers();
}, [countryCode, phoneNumberType, EncryptedInstanceId, customerAWSAccountId, region]);

  // Fetch contact flow list
  useEffect(() => {
    const fetchcontactflowList = async () => {
      const payload = {
        ID: EncryptedInstanceId,
        awsAccount: customerAWSAccountId,
        region: region
      };

      try {
        const response = await axiosInstance.post(
          endpoints.displayContactflowlist.flowlist,
          payload
        );

        const parsedBody = JSON.parse(response.data.body);
        if (Array.isArray(parsedBody)) {
          const extractedData = parsedBody.map(flow => ({ flowName: flow }));
          setflowList(extractedData);
        }
      } catch (error) {
        console.error("Error fetching contact flow list:", error);
      }
    };

    fetchcontactflowList();
  }, [EncryptedInstanceId, customerAWSAccountId, region]);

  const AddPhoneNumberwithflow = async () => {
    const payload = {
      Action: "associate",
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region,
      InstanceAlias: instanceAlias,
      PhoneNumber: phoneNumber,
      ContactFlowName: contactFlow,
    };

    await axiosInstance.post(
      endpoints.displayflowassociate.flowassociate,
      payload
    );
  };

  const fetchUpdatedPhoneNumbers = async () => {
    const body = {
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region,
      InstanceAlias: instanceAlias,
      Action: "list",
    };

    const response = await axiosInstance.post(
      endpoints.displayPhoneNumberlist.phoneNumber,
      body
    );

    const data = JSON.parse(response.data.body);
    return Array.isArray(data) ? data : [];
  };

  const handleAddPhoneNumber = async () => {

     let newErrors = {};


  if (!countryCode) {
    newErrors.countryCode = "Country code is required";
  }
  if (!phoneNumber) {
    newErrors.phoneNumber = "Phone number is required";
  }
  if (phoneNumber && !countryCode) {
    newErrors.countryCode = "Select country code before choosing a phone number";
  }

  // If errors exist, stop execution
  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  // clear errors if validation passes
  setErrors({  countryCode: "", phoneNumber: "" });

     setActionClicked("save");
    setLoading(true);

    const payload = {
      Action: "claimphonenumber",
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      InstanceAlias: instanceAlias,
       UserName:username, 
       Email:email,
      region,
      PhoneNumber: phoneNumber,
      PhoneNumberDescription: description,
    };

    try {
      await axiosInstance.post(
        endpoints.displayPhoneNumberlist.phoneNumber,
        payload
      );

      if (contactFlow) {
        await AddPhoneNumberwithflow();
      }

      const updatedPhoneList = await fetchUpdatedPhoneNumbers();
      onAddSuccess(updatedPhoneList);
      onClose();
    } catch (error) {
      console.error("Error adding phone number:", error);
    } finally {
      setLoading(false);
       setActionClicked(null);
    }
  };

  const handleCancel = () => {
     setActionClicked("cancel");
    setCancelButtonLoading(true);
    setTimeout(() => {
      setCancelButtonLoading(false);
      setActionClicked(null);
      onClose();
    }, 300);
  };

  return (
    <Container className="addqueue-content-container">
     <Box display="flex" flexDirection="column" alignItems="flex-start" mb={2} gap={1}>
        <IconButton
          onClick={onClose}
          size="medium"
          sx={{
            border: "1px solid #ccc",       // border color
            borderRadius: "50%",            // makes it circular
            padding: 1,                     // inner spacing
            bgcolor: "#f5f5f5",             // background color
            "&:hover": { bgcolor: "#e0e0e0" } // hover effect
          }}
        >
          <ArrowBackIcon />
        </IconButton>
       {/* Title */}
       <Typography variant="h4" className="phone-text">
         Add Phone Number
       </Typography>
     </Box>

      <Box className="form-section">
        <Typography className="channel-text">
          Choose channel
        </Typography>
        <Typography>Select your preferred contact method.</Typography>

        <FormControl component="fieldset">
          <RadioGroup
            value={selectedMethod}
            onChange={(e) => setSelectedMethod(e.target.value)}
          >
            <FormControlLabel
              value="voice"
              control={<Radio />}
              label={
                <Box>
                  <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                    Voice
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Search and claim available phone numbers in your desired region
                  </Typography>
                </Box>
              }
            />
          </RadioGroup>
        </FormControl>
      </Box>

      <Box className="form-section">
        
        <Typography className="channel-text">Choose Phone Number</Typography>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
        >
          <Tab label="Toll Free" />
          <Tab label="DID" />
        </Tabs>

        {/* Country Code + Phone Number on one line */}
        <Box
          display="flex"
          gap={2}
          mt={2}
        >
        <TextField
  label="Select Country Code"
  placeholder="Choose country code"
  required
  select
  value={countryCode} // stores "CA", "US", etc.
  onChange={handleCountryCodeChange}
  sx={{ minWidth: 200 }}
  error={!!errors.countryCode}
  helperText={errors.countryCode}
>
  {currentCountryOptions.map((option) => (
    <MenuItem key={option.code} value={option.code}>
      {option.label} ({option.value})
    </MenuItem>
  ))}
</TextField>

<TextField
  select
  fullWidth
  label="Phone Number"
  value={phoneNumber}
  onChange={(e) => {
    setPhoneNumber(e.target.value);
    setErrors((prev) => ({ ...prev, phoneNumber: "" }));
  }}
  disabled={!countryCode}
  error={!!errors.phoneNumber}
  helperText={errors.phoneNumber}
>
  {!countryCode ? (
    <MenuItem disabled>Select country code first</MenuItem>
  ) : availableNumbers === null ? (
    <MenuItem disabled>Loading numbers...</MenuItem>
  ) : availableNumbers.length === 0 ? (
    <MenuItem disabled>
      There are no available phone numbers for the selected country.
      Please create a support case to request phone numbers.
    </MenuItem>
  ) : (
    availableNumbers.map((num, i) => (
      <MenuItem key={i} value={num}>
        {num}
      </MenuItem>
    ))
  )}
</TextField>

        </Box>
      </Box>

      <Box className="form-section">
        <Typography variant="h4">Optional Info</Typography>
        <Box
          display="flex"
          gap={2}
          mt={2}
        >
          <TextField
            label="Description"
            fullWidth
            placeholder="Enter description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <TextField
            label="Contact Flow / IVR"
            placeholder="Select contact flow"
            select
            fullWidth
            value={contactFlow}
            onChange={(e) => setFlow(e.target.value)}
          >
            {flowList.length > 0 ? (
              flowList.map((flow, i) => (
                <MenuItem key={i} value={flow.flowName}>
                  {flow.flowName}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No contact flows available</MenuItem>
            )}
          </TextField>
        </Box>
      </Box>

      <div className="buttons-addhour">
        <Button
          onClick={handleCancel}
         disabled={actionClicked === "save" || cancelButtonLoading}
      >
        {actionClicked === "cancel" ? <CircularProgress size={18} /> : "Cancel"}
        </Button>
        <Button
          onClick={handleAddPhoneNumber}
          variant="contained"
          disabled={actionClicked === "cancel" || loading}
      >
        {actionClicked === "save" ? (
          <CircularProgress size={18} sx={{ color: "white" }} />
        ) : (
          "Save"
        )}
        </Button>
      </div>
    </Container>
  );
};

export default AddPhoneNumber;